"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockContainer = exports.ErrorBlockContainer = exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _compat = require("compat");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _class3, _descriptor4, _temp2, _class5, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _class6, _temp3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Block = (_class5 = (_temp3 = _class6 =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Block, _Component);

  function Block() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, Block);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(Block)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "className", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "style", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "nodeName", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "attributes", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "defaultHeight", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "background", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "id", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "block_type", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    _this3.state = {
      hidden: false,
      firstPass: false
    };
    _this3.backgroundStyleValue = _this3.backgroundStyle();
    _this3.extraAttributes = {};
    return _this3;
  }

  babelHelpers.createClass(Block, [{
    key: "hide",
    value: function hide() {
      this.setState({
        hidden: true
      });
    }
  }, {
    key: "show",
    value: function show() {
      this.setState({
        hidden: false
      });
    }
  }, {
    key: "backgroundStyle",
    value: function backgroundStyle() {
      return Block.styleForBackgroundObject(this.background, this.state.firstPass);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      Block.firstPass = true;
      this.setState({
        firstPass: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(newProps) {
      if (newProps.background !== this.background) this.backgroundStyleValue = this.backgroundStyle();
    }
  }, {
    key: "render",
    value: function render() {
      var Node = this.nodeName;

      if (this.props.noChildren === true) {
        return _react.default.createElement(Node, _extends({
          className: _classList.default.join('block', this.className, "height-".concat(this.height), this.background ? "transparent variable-background" : ''),
          "data-block-id": this.id,
          "data-block-type": this.block_type,
          style: Object.assign({}, this.backgroundStyleValue, this.style || {})
        }, this.attributes, this.extraAttributes));
      }

      return _react.default.createElement(Node, _extends({
        className: _classList.default.join('block', this.className, "height-".concat(this.height), this.background ? "transparent variable-background" : ''),
        "data-block-id": this.id,
        "data-block-type": this.block_type,
        style: Object.assign({}, this.backgroundStyleValue, this.style || {}, this.state.hidden ? {
          display: 'none'
        } : {})
      }, this.attributes, this.extraAttributes), this.getChildren());
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this.props.children;
    }
  }, {
    key: "height",
    get: function get() {
      if (this.props.height) return this.props.height;
      return this.defaultHeight;
    }
  }], [{
    key: "trimHTML",
    value: function trimHTML(text) {
      text = text.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').replace(/^\s*/, '').replace(/\s*$/, '');
      var t1 = text.substring(0, 25);
      return text == t1 ? text : "".concat(t1, "...");
    }
  }, {
    key: "styleForBackgroundObject",
    value: function styleForBackgroundObject(background) {
      var firstPass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Block.firstPass;

      if (background) {
        if (firstPass && _compat.Info.cssVariables) {
          var r = {
            '--landscape-background': "url(".concat(background.landscape, ")"),
            '--portrait-background': "url(".concat(background.portrait, ")"),
            '--landscape-600px-background': "url(/t/width=600/scale/f".concat(background.landscape, "/scaled.jpg)"),
            '--portrait-600px-background': "url(/t/width=600/scale/f".concat(background.portrait, "/scaled.jpg)"),
            'background-image': 'var(--image-overlay), var(--selected-background)'
          };

          if (background.imageOverlayCustom) {
            r['--image-overlay'] = background.imageOverlay;
          }

          return r;
        }

        return {
          'background-image': "".concat(background.imageOverlay, ", url(").concat(background.landscape, ")")
        };
      }

      return {};
    }
  }]);
  return Block;
}(_react.Component), _class6.firstPass = false, _temp3), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "style", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "nodeName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "div";
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "attributes", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "defaultHeight", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'auto';
  }
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "background", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "block_type", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.default = Block;

var ErrorBlockContainer =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(ErrorBlockContainer, _Block);

  function ErrorBlockContainer() {
    babelHelpers.classCallCheck(this, ErrorBlockContainer);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ErrorBlockContainer).apply(this, arguments));
  }

  babelHelpers.createClass(ErrorBlockContainer, null, [{
    key: "withError",
    value: function withError(e) {
      var _class, _descriptor, _descriptor2, _descriptor3, _class2, _temp;

      return _class = (_temp = _class2 =
      /*#__PURE__*/
      function (_ErrorBlockContainer) {
        babelHelpers.inherits(_class, _ErrorBlockContainer);

        function _class() {
          var _babelHelpers$getProt;

          var _this;

          babelHelpers.classCallCheck(this, _class);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(_class)).call.apply(_babelHelpers$getProt, [this].concat(args)));
          babelHelpers.initializerDefineProperty(_this, "height", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
          babelHelpers.initializerDefineProperty(_this, "style", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
          babelHelpers.initializerDefineProperty(_this, "children", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
          return _this;
        }

        return _class;
      }(ErrorBlockContainer), _class2.error = e, _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "height", [_decorators.prop], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function initializer() {
          return 'auto';
        }
      }), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "style", [_decorators.prop], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function initializer() {
          return {
            backgroundColor: '#ccc',
            whiteSpace: 'pre',
            fontFamily: 'monospace'
          };
        }
      }), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function initializer() {
          return "Could not render block ".concat(this.child_type, " ").concat(this.id, ": ").concat(e.stack);
        }
      })), _class;
    }
  }, {
    key: "value",
    value: function value(block) {
      return {
        child_type: 'block/base',
        id: block.id,
        height: 'auto',
        style: {
          backgroundColor: '#ccc',
          whiteSpace: 'pre',
          fontFamily: 'monospace'
        },
        children: "Could not render block ".concat(block.child_type, " ").concat(block.id, ": ").concat(this.error.stack)
      };
    }
  }]);
  return ErrorBlockContainer;
}(Block);

exports.ErrorBlockContainer = ErrorBlockContainer;
var BlockContainer = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Block2) {
  babelHelpers.inherits(BlockContainer, _Block2);

  function BlockContainer() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, BlockContainer);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(BlockContainer)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "isRootBlock", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(BlockContainer, [{
    key: "render",
    value: function render() {
      if (this.isRootBlock) {
        return _react.default.createElement("div", {
          id: "page-content-container"
        }, this.getChildren());
      }

      return babelHelpers.get(babelHelpers.getPrototypeOf(BlockContainer.prototype), "render", this).call(this);
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement.apply(_react.default, [_react.default.Fragment, {}].concat(babelHelpers.toConsumableArray(this.props.content.map(function (node) {
        return _react.default.createElement(BlockContainer.rawBlock(node.child_type), node);
      })))); // return this.props.content.map(node => React.createElement(BlockContainer.rawBlock(node.child_type), Object.assign({ key: node.id }, node)));
    }
  }], [{
    key: "rawBlock",
    value: function rawBlock(node) {
      try {
        var r = require(node).default;

        if (!r) {
          throw new Error("Module ".concat(node, " does not export default class"));
        }

        return r;
      } catch (e) {
        return ErrorBlockContainer.withError(e);
      }
    }
  }, {
    key: "block",
    value: function block(node) {
      return this.rawBlock("block/".concat(node.child_type));
    }
  }]);
  return BlockContainer;
}(Block), _temp2), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "isRootBlock", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.BlockContainer = BlockContainer;